import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { EnvironmentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { Store, select } from '@ngrx/store';
import { Observable, ReplaySubject, of } from 'rxjs';
import { distinctUntilChanged, mergeMap, takeUntil } from 'rxjs/operators';
import { Language } from '@app/shared/types/Language';

@Injectable({
  providedIn: 'root'
})
export class SwitchLanguageGuard  {

  constructor(
    private store$: Store<fromRoot.State>
  ) { }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.store$.dispatch(EnvironmentActions.SelectLanguage({ language: next.routeConfig.path as Language }));
    return this.selectLanguage(next.routeConfig.path).pipe(mergeMap((ok) => {
      if (ok) {
        return of(true)
      }
    }));
  }

  selectLanguage(targetLanguage): Observable<boolean> {
    const selectLanguage$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      select(fromRoot.getSelectedLanguage),
      distinctUntilChanged(),
      takeUntil(selectLanguage$),
    ).subscribe((selectedLanguage: string) => {
      if (selectedLanguage === targetLanguage) {
        selectLanguage$.next(true);
      }
    });
    return selectLanguage$.asObservable();
  }

}
